/*
 * @Author: Gang Jiang 
 * @Date: 2024-10-31 13:51:21 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2024-11-23 14:30:15
 */

<template>
  <div
    ref="invitation"
    class="invitation"
  >
    <div class="content">
      <a-form
        :ref="formRef"
        :model="filter"
      >
        <a-row
          class="search"
          :gutter="40"
        >
          <a-col :span="5">
            <a-form-item label="Name">
              <a-input
                v-model:value="filter.name"
                placeholder="Please enter"
                @pressEnter="onSearch"
              />
            </a-form-item>
          </a-col>
          <a-col :span="5">
            <a-form-item label="Email">
              <a-input
                v-model:value="filter.email"
                placeholder="Please enter"
                @pressEnter="onSearch"
              />
            </a-form-item>
          </a-col>
          <a-col :span="7">
            <a-form-item label="Create Time">
              <a-range-picker
                v-model:value="filterDate"
                :style="{ width: '220px' }"
                format="YYYY-MM-DD"
                :allow-clear="true"
                :placeholder="['Start date', 'End date']"
                @change="setFilterDate"
              />
            </a-form-item>
          </a-col>
          <a-col
            :span="7"
            class="btns"
          >
            <a-button
              type="primary"
              @click="onSearch"
            >
              Search
            </a-button>
            <a-button @click="resetSearch">
              Reset
            </a-button>
            <a-button
              type="primary"
              @click="showCreateInvitationModal = true"
            >
              Create Invitation
            </a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="content">
      <a-table
        :columns="columns"
        :data-source="invitationlist"
        :pagination="pagination"
        :scroll="{ x: 1000 }"
      >
        <template #bodyCell="{ column, record, index }">
          <template v-if="column.key === 'action'">
            <a-flex
              class="actions"
              gap="20"
            >
              <div
                v-if="record.reviewStatus === 'Approved'"
                class="email"
              >
                <span
                  v-if="record.sendInvitationCode"
                  class="email-sent"
                >Email sent</span>
                <a
                  v-if="record.sendInvitationCode"
                  href="javascript:;"
                  class="send-email"
                  @click="sendInvitationEmail(index, record)"
                >Send Again</a>
                <a
                  v-if="!record.sendInvitationCode"
                  href="javascript:;"
                  @click="sendInvitationEmail(index, record)"
                >Send Email</a>
              </div>
              <a-popconfirm
                v-if="record.reviewStatus === 'Approved'"
                title="Are you sure to delete it?"
                ok-text="Yes"
                cancel-text="No"
                @confirm="deleteInvitation(record.id)"
              >
                <a
                  href="javascript:;"
                  class="delete"
                >Delete</a>
              </a-popconfirm>
              <a
                href="javascript:;"
                @click="emit('setShowLogModalId', record.id)"
              >Log</a>
            </a-flex>
          </template>
          <template
            v-else-if="column.key === 'name' || column.key === 'invitationCode'"
          >
            <p
              class="multiple3"
              :title="record[column.key]"
            >
              {{ record[column.key] }}
            </p>
          </template>
          <template
            v-else-if="
              column.key === 'invitationCodeCreateTime' ||
                column.key === 'invitationCodeExpireTime'
            "
          >
            {{
              record[column.key]
                ? moment(record[column.key]).format(
                  'YYYY-MM-DD' +
                    (column.key === 'invitationCodeExpireTime'
                      ? ''
                      : ' HH:mm:ss')
                )
                : '-'
            }}
          </template>
        </template>
      </a-table>
    </div>
    <a-modal
      :open="showCreateInvitationModal"
      ok-text="Save"
      :width="560"
      title="Create Invitation"
      :get-container="() => $refs.invitation"
      @cancel="hideModal"
    >
      <template #footer>
        <a-row
          class="footer"
          :gutter="[10, 0]"
        >
          <a-col
            :offset="6"
            :span="9"
          >
            <a-button
              key="submit"
              type="primary"
              :loading="loading"
              @click="createInvitation"
            >
              Save
            </a-button>
          </a-col>
          <a-col :span="9">
            <a-button @click="hideModal">
              Cancel
            </a-button>
          </a-col>
        </a-row>
      </template>
      <a-form
        :model="newInvitation"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-form-item
          name="name"
          label="Name"
          :help="validateInfo.name?.help"
          :validate-status="validateInfo.name?.status"
        >
          <a-input
            ref="nameRef"
            v-model:value="newInvitation.name"
            placeholder="Please enter"
            :maxlength="100"
            item-type="name"
            @keyup="setInvitationCode"
            @blur="validateInvitation"
            @focus="validateInvitation"
          />
        </a-form-item>
        <a-form-item
          name="email"
          label="Email"
          :help="validateInfo.email?.help"
          :validate-status="validateInfo.email?.status"
        >
          <a-input
            ref="emailRef"
            v-model:value="newInvitation.email"
            type="email"
            :maxlength="100"
            item-type="email"
            placeholder="Please enter"
            @blur="validateInvitation"
            @focus="validateInvitation"
          />
        </a-form-item>
        <a-form-item
          name="invitationCode"
          label="Invitation Code"
          :help="validateInfo.code?.help"
          :validate-status="validateInfo.code?.status"
        >
          <a-input
            ref="codeRef"
            v-model:value="newInvitation.invitationCode"
            item-type="code"
            placeholder="Please enter"
            :maxlength="100"
            @blur="validateInvitation"
            @focus="validateInvitation"
          />
        </a-form-item>
        <a-form-item
          name="expireTime"
          label="End Time"
        >
          <a-date-picker
            v-model:value="expireTime"
            class="expire-time"
            placeholder="End date"
            :disabled-date="disabledDate"
          />
        </a-form-item>
        <a-form-item
          :label-col="{ span: 0 }"
          :wrapper-col="{ span: 24 }"
          class="social-platform-formitem"
          :help="validateInfo.homepage?.help"
          :validate-status="validateInfo.homepage?.status"
        >
          <a-row>
            <a-col :span="6">
              <a-select
                :options="socialPlatforms"
                :value="newInvitation.socialPlatforms[0].platformId"
                :dropdown-match-select-width="false"
                @change="setSocialPlatform"
              />
            </a-col>
            <a-col
              :span="18"
            >
              <a-input
                v-model:value="newInvitation.socialPlatforms[0].homepage"
                :max-length="1000"
                item-type="homepage"
                :placeholder="homepagePlaceholder"
                @blur="validateInvitation"
                @focus="validateInvitation"
              />
            </a-col>
          </a-row>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script setup>
import { ref, reactive, computed } from 'vue'
import { influencers } from '../../server'
import moment from 'moment'
import { message, Form } from 'ant-design-vue'

const loading = ref(false)
const emit = defineEmits(['setLoading', 'setShowLogModalId'])
const nameRef = ref(null)
const codeRef = ref(null)
const emailRef = ref(null)
const validateInfo = ref({
  name: null,
  email: null,
  code: null,
  homepage: null,
})
const pagination = ref({
  current: 1,
  pageSize: 200,
  total: 0,
  showSizeChanger: false,
  onChange: (page) => {
    search.page = page
    getList()
  },
})
const initialFilters = {
  page: 1,
  size: 200,
  name: null,
  email: null,
  endTime: null,
  startTime: null,
}
const search = reactive({ ...initialFilters })
const filter = reactive({ ...initialFilters })
let defaultPlatform = {}
const expireTime = ref(moment().add(30, 'days'))
const defaultInvitation = reactive({
  name: '',
  email: '',
  invitationCode: '',
  invitationCodeExpireTime: moment().add(30, 'days'),
  socialPlatforms: [
    {
      homepage: '',
      platformId: -1,
    },
  ],
})
const newInvitation = ref({ ...defaultInvitation.value })
const useForm = Form.useForm
const socialPlatforms = ref([])
const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 75,
    fixed: 'left',
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    width: 130,
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    width: 200,
  },
  {
    title: 'Invitation Code',
    dataIndex: 'invitationCode',
    key: 'invitationCode',
    width: 140,
  },
  {
    title: 'Create Time',
    dataIndex: 'invitationCodeCreateTime',
    key: 'invitationCodeCreateTime',
    width: 180,
  },
  {
    title: 'End Time',
    dataIndex: 'invitationCodeExpireTime',
    key: 'invitationCodeExpireTime',
    width: 116,
  },
  {
    title: 'Status',
    dataIndex: 'reviewStatus',
    key: 'reviewStatus',
    width: 100,
  },
  {
    title: 'Action',
    key: 'action',
    fixed: 'right',
    width: 300,
  },
]
const invitationlist = ref([])
const filterDate = ref([null, null])
const showCreateInvitationModal = ref(false)

const disabledDate = (current) => {
  return current.isBefore(moment().subtract(1, 'days'))
}

function resetSearch() {
  Object.assign(search, initialFilters)
  Object.assign(filter, initialFilters)
  filterDate.value = [null, null]
  getList()
}

function onSearch() {
  Object.assign(search, {
    ...filter,
    page: 1,
  })
  getList()
}

function setFilterDate(values) {
  filter.startTime = values[0].startOf('date').valueOf()
  filter.endTime = values[1].endOf('date').valueOf()
}

function getList() {
  const params = { ...search }

  Object.keys(params).forEach((key) => {
    if (params[key] == null || params[key] == '' || params[key] == undefined) {
      delete params[key]
    }
  })

  emit('setLoading', true)
  influencers.invitationList(params).then((res) => {
    emit('setLoading', false)

    if (res.success) {
      invitationlist.value = res.data
      pagination.value.current = search.page

      if (search.page === 1) {
        pagination.value.total = res.total
      }
    }
  })
}

getList()
const { resetFields } = useForm(newInvitation)

influencers.getSocialPlatformsList().then((res) => {
  socialPlatforms.value = res.data.map((inner) => {
    if (inner.name === 'Instagram') {
      defaultPlatform = {
        platformId: inner.id,
        value: inner.id,
        homepage: '',
        label: inner.name,
      }
      defaultInvitation.socialPlatforms = [defaultPlatform]
      newInvitation.value.socialPlatforms = [defaultPlatform]
    }

    return {
      ...inner,
      label: inner.name,
      value: inner.id,
    }
  })
})

function getPlatformKey(platform) {
  return String(
    platform?.platformName || platform?.name || platform?.label || ''
  )
    .trim()
    .toLowerCase()
    .replace(/\.$/, '')
}

const HOMEPAGE_PLACEHOLDER_MAP = {
  instagram: 'e.g. www.instagram.com/xxx',
  youtube: 'e.g. www.youtube.com/@xxx',
  linktree: 'e.g. linktr.ee/xxx',
  facebook: 'e.g. www.facebook.com/xxx',
  x: 'e.g. x.com/xxx',
  twitter: 'e.g. x.com/xxx',
  tiktok: 'e.g. www.tiktok.com/@xxx',
  red: 'e.g. xhslink.com/xxx',
  xiaohongshu: 'e.g. xhslink.com/xxx',
  wechat: 'wechat username',
  weibo: 'e.g. weibo.com/xxx',
  blog: 'Please fill in URL',
  website: 'Please fill in URL',
  others: 'Please fill in URL',
  other: 'Please fill in URL',
}

// 社交平台域名匹配；Wechat 不校验；Blog/Website/Others 校验 URL 格式
const HOMEPAGE_DOMAIN_MAP = {
  instagram: ['instagram.com'],
  youtube: ['youtube.com'],
  linktree: ['linktr.ee'],
  facebook: ['facebook.com'],
  x: ['x.com'],
  twitter: ['x.com'],
  tiktok: ['tiktok.com'],
  red: ['xhslink.com', 'xhslink.cn'],
  xiaohongshu: ['xhslink.com', 'xhslink.cn'],
  weibo: ['weibo.com'],
}
const HOMEPAGE_URL_FORMAT_KEYS = new Set(['blog', 'website', 'others', 'other'])
const HOMEPAGE_SKIP_VALIDATE_KEYS = new Set(['wechat'])

function isValidUrlFormat(val) {
  // 只校验 URL 格式规范，不强制 https
  const input = String(val).trim().replace(/^https?:\/\//i, '')
  return /^[\w-]+(\.[\w-]+)+([/?#][^\s]*)?$/i.test(input)
}

function getHomepageValidationHelp(val, platform) {
  const key = getPlatformKey(platform)
  if (!key || HOMEPAGE_SKIP_VALIDATE_KEYS.has(key)) return ''

  const domains = HOMEPAGE_DOMAIN_MAP[key]
  if (HOMEPAGE_URL_FORMAT_KEYS.has(key) && !isValidUrlFormat(val)) {
    return 'Please enter a valid URL'
  }
  if (domains) {
    const lower = String(val).toLowerCase()
    if (!domains.some((domain) => lower.includes(domain))) {
      return `Please enter a valid social media link, or select "Others" as the link type.`
    }
    return ''
  }

  

  return ''
}

const homepagePlaceholder = computed(() => {
  const name = getPlatformKey(newInvitation.value?.socialPlatforms?.[0])
  if (!name) return 'URL or Username'
  return HOMEPAGE_PLACEHOLDER_MAP[name] || 'Please fill in URL'
})

function setSocialPlatform(value, option) {
  newInvitation.value = {
    ...newInvitation.value,
    socialPlatforms: [
      {
        ...option,
        platformId: option.id,
        platformName: option.name || option.label,
        homepage: newInvitation.value.socialPlatforms[0]?.homepage || '',
      },
    ],
  }
  validateInvitation({
    value: newInvitation.value.socialPlatforms[0].homepage,
    item: 'homepage',
    type: 'change',
  })
}

function validateInvitation(e) {
  const val = e.target ? e.target.value.trim() : e.value
  const type = e.target?.getAttribute('itemType') || e.item

  if (e.type == 'focus') {
    validateInfo.value[type] = {
      help: '',
      status: '',
    }
  } else {
    let help = ''

    if (val?.length) {
      if (type == 'code' && val.length < 6) {
        help = 'Invalid code! Code must be between 6 and 100 characters.'
      } else if (
        type == 'email' &&
        !/^[\w\d.-]+@[\w\d-]+(?:\.[\w\d-]+)+$/.test(val)
      ) {
        help = 'The email is not valid.'
      } else if (type == 'homepage') {
        help = getHomepageValidationHelp(
          val,
          newInvitation.value.socialPlatforms[0]
        )
      }
    } else {
      help =
        type == 'homepage'
          ? 'Please enter the homepage'
          : `Please enter the ${type}`
    }

    validateInfo.value[type] = {
      help,
      status: help.length ? 'error' : '',
    }
  }
}

// 只能输入字符和数字
function setInvitationCode(e) {
  const value = e.target.value

  newInvitation.value.name = value

  if (value.length) {
    const code = (
      value.replace(/[^a-zA-Z0-9]|\s/g, '') + moment().format('YYYY')
    ).substring(0, 100)

    newInvitation.value.invitationCode = code
    validateInvitation({
      value: code,
      item: 'code',
      type: 'change',
    })
  } else {
    newInvitation.value.invitationCode = ''
  }
}

function createInvitation() {
  validateInvitation({
    value: newInvitation.value.name,
    item: 'name',
    type: 'change',
  })

  validateInvitation({
    value: newInvitation.value.email,
    item: 'email',
    type: 'change',
  })
  validateInvitation({
    value: newInvitation.value.invitationCode,
    item: 'code',
    type: 'change',
  })
  validateInvitation({
    value: newInvitation.value.socialPlatforms[0]?.homepage,
    item: 'homepage',
    type: 'change',
  })

  if (
    !validateInfo.value.name.help.length &&
    !validateInfo.value.email.help.length &&
    !validateInfo.value.code.help.length &&
    !validateInfo.value.homepage.help.length
  ) {
    const params = {
      ...newInvitation.value,
      invitationCodeExpireTime: expireTime.value?.endOf('date').valueOf(),
    }

    loading.value = true

    influencers.createInvitation(params).then((res) => {
      loading.value = false

      if (res.success) {
        message.success('Invitation created successfully.')
        pagination.value.page = 1
        getList()
        hideModal()
      } else {
        message.error(
          res.error || 'Fail to create invitation, please try again.'
        )
      }
    })
  }
}

function sendInvitationEmail(index, influencer) {
  emit('setLoading', true)

  influencers.sendInvitationEmail(influencer.id).then((res) => {
    emit('setLoading', false)

    if (res.success) {
      invitationlist.value[index] = {
        ...influencer,
        sendInvitationCode: true,
      }
      message.success('Email sent.')
    } else {
      message.error('Fail to send email, please try again.')
    }
  })
}

function deleteInvitation(id) {
  emit('setLoading', true)

  influencers.deleteInvitation(id).then((res) => {
    emit('setLoading', false)

    if (res.success) {
      message.success('Invitation has been deleted successfully.')
      search.page = 1
      getList()
    } else {
      message.error('Fail to delete invitation, please try again.')
    }
  })
}

function hideModal() {
  newInvitation.value = {
    ...defaultInvitation.value,
    socialPlatforms: [{ ...defaultPlatform, homepage: '' }],
  }
  showCreateInvitationModal.value = false
  expireTime.value = moment().add(30, 'days')
  validateInfo.value = {
    name: null,
    code: null,
    email: null,
    homepage: null,
  }
  resetFields()
}

defineExpose({
  tabChanged: resetSearch,
})
</script>

<style lang="less" scoped>
@import '../../assets/less/common.less';
.multiple3 {
  max-width: 200px;
  max-height: 66px;
  .multiple-ellipsis(3);
}
.invitation {
  margin-bottom: 20px;
  :deep(.ant) {
    &-modal {
      &-title {
        text-align: center;
      }
      .ant-btn {
        width: 100%;
      }
    }
    &-form-item-explain-error {
      position: absolute;
    }
  }
  .expire-time {
    width: 100%;
  }
}
.search {
  .btns {
    :deep(.ant) {
      &-btn {
        margin-left: 10px !important;
        &:first-of-type {
          margin-left: 0;
        }
      }
    }
  }
}

.actions {
  .email-sent {
    margin-right: 20px;
    white-space: nowrap;
  }
  .send-email {
    white-space: nowrap;
  }
  .delete:hover {
    color: #ff4d4f;
  }
}

.social-platform-formitem {
  padding: 10px;
  margin: 0 -10px;
  border-radius: 6px;
  background-color: #f2f2f2;
  :deep(.ant) {
    &-select-selector {
      border: none;
      box-shadow: none !important;
      background-color: transparent;
    }
  }
}
</style>